import { InfoAlert } from 'app/components'

/** Erros sem campo (422 geral, 409 etc.) no topo dos modais da gestão. */
export const ErrosGerais = ({ erros }: { erros: string[] }) =>
  erros.length > 0 ? (
    <InfoAlert variant='danger' role='alert'>
      {erros.map((mensagem) => (
        <div key={mensagem}>{mensagem}</div>
      ))}
    </InfoAlert>
  ) : null
